import { FetchCacheItemsSources } from '../../../../types';
import { PermissionAction } from '../../../permissions/permissionsTypes';
import { CacheInfiniteIndexQueryBaseNodeType } from '../../../common/reactQuery/hooks/useCacheInfiniteIndexQuery';
import {
  FetchCurrencyRatesFilters,
  FetchCurrencyRatesSort,
  FetchCurrencyRatesLimit,
  FetchCurrencyRatesGqlQuery,
  FetchCurrencyRatesCacheKey
} from '../../currencyRatesTypes';

import { useCacheInfiniteIndexQuery } from '../../../common/reactQuery/hooks/useCacheInfiniteIndexQuery';

import {
  INITIAL_CURRENCY_RATES_FILTERS,
  INITIAL_CURRENCY_RATES_LIMIT,
  INITIAL_CURRENCY_RATES_SORT
} from '../../currencyRatesConstants';

interface CurrencyRatesOptions {
  action?: PermissionAction;
  cacheKey: FetchCurrencyRatesCacheKey;
  query: FetchCurrencyRatesGqlQuery;
  initialFilters?: FetchCurrencyRatesFilters;
  initialSort?: FetchCurrencyRatesSort;
  initialLimit?: FetchCurrencyRatesLimit;
  source?: FetchCacheItemsSources;
  options?: {
    cacheTime?: number;
  };
}

const scope = 'currencyRates';

function useCurrencyRates<
  CurrencyRateItemType extends CacheInfiniteIndexQueryBaseNodeType
>({
  action,
  cacheKey,
  query,
  initialFilters = INITIAL_CURRENCY_RATES_FILTERS,
  initialSort = INITIAL_CURRENCY_RATES_SORT,
  initialLimit = INITIAL_CURRENCY_RATES_LIMIT,
  source = FetchCacheItemsSources.DB,
  options = {}
}: CurrencyRatesOptions) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isLoading,
    isFetchingNextPage,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    hasNextPage,
    updateItemCache,
    loadMoreItems,
    clearItemsFilters,
    filterItems,
    sortItems,
    limitItems
  } = useCacheInfiniteIndexQuery<CurrencyRateItemType>({
    action,
    cacheKey,
    defaultApi: 'cache_api',
    initialFilters,
    initialLimit,
    initialSort,
    options,
    query,
    scope,
    source,
    trackTotalHits: true
  });

  return {
    currencyRatesData: data,
    currencyRates: items,
    currencyRatesError: itemsError,
    currencyRatesTotalCount: itemsTotalCount,
    currencyRatesFetched: isFetched,
    currencyRatesLoading: isLoading,
    currencyRatesFetchingNextPage: isFetchingNextPage,
    currencyRatesIsPlaceholderData: isPlaceholderData,
    currencyRatesFilters: currentFilters,
    currencyRatesSort: currentSort,
    currencyRatesPage: currentPage,
    currencyRatesLimit: currentLimit,
    hasNextCurrencyRatesPage: hasNextPage,
    updateDownloadCache: updateItemCache,
    loadMoreCurrencyRates: loadMoreItems,
    filterCurrencyRates: filterItems,
    clearCurrencyRatesFilters: clearItemsFilters,
    sortCurrencyRates: sortItems,
    limitCurrencyRates: limitItems
  };
}

export default useCurrencyRates;
